import {
    Selector,
    createSelector,
} from 'reselect';
import { NAMESPACE } from './constant';
import { initialState } from './reducer';
import { RootState } from '@vfde-sails/core';
import {
    CaptchaMediaType,
    ICustomerInformation,
    IError,
    IStateCancellationForm,
} from './interface';

const selectCancellationFormDomain = (state: RootState<IStateCancellationForm>) =>
    state[NAMESPACE] || initialState;

const selectCustomerInformation = (): Selector<RootState<IStateCancellationForm>, ICustomerInformation | null> =>
    createSelector(selectCancellationFormDomain, state => state.customerInformation);

const selectError = (): Selector<RootState<IStateCancellationForm>, IError | null> =>
    createSelector(selectCancellationFormDomain, state => state.error);

const selectCaptchaUrl = (): Selector<RootState<IStateCancellationForm>, string | null> =>
    createSelector(selectCancellationFormDomain, state => state.captchaUrl);

const selectCaptchaMediaType = (): Selector<RootState<IStateCancellationForm>, CaptchaMediaType | null> =>
    createSelector(selectCancellationFormDomain, state => state.captchaMediaType);

const selectCaptchaHash = (): Selector<RootState<IStateCancellationForm>, string | null> =>
    createSelector(selectCancellationFormDomain, state => state.captchaHash);

export {
    selectCancellationFormDomain,
    selectCustomerInformation,
    selectError,
    selectCaptchaUrl,
    selectCaptchaMediaType,
    selectCaptchaHash,
};
